import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { uniqBy } from 'lodash';

import { ALL_RECORDS_CQL } from '@app/components';
import { axios } from '@app/utils';
import { DepartmentInstructorItemDto, SORT_DIRECTION } from '@app/constants';

import { BrowseByField } from './constants';

export const useDepartmentsInstructorsFetch = (
  fieldName: BrowseByField
): UseQueryResult<DepartmentInstructorItemDto[]> => {
  return useQuery([`${fieldName}List`], () =>
    axios
      .get<Record<BrowseByField, DepartmentInstructorItemDto[]>>(
        `/opac-courses/${fieldName}`,
        {
          params: {
            limit: 1000,
            query: `${ALL_RECORDS_CQL} sortBy name/sort.${SORT_DIRECTION.asc}`,
          },
        }
      )
      .then(response => uniqBy(response.data?.[fieldName], 'name'))
  );
};
